import { useEffect, useState } from 'react';

type UseIsStuckToBottomResult = {
  isStuck: boolean;
  sentinelRef: (element: HTMLElement | null) => void;
};

export const useIsStuckToBottom = (): UseIsStuckToBottomResult => {
  const [sentinel, setSentinel] = useState<HTMLElement | null>(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    if (!sentinel) {
      return;
    }
    const observer = new IntersectionObserver(([entry]) => setIsStuck(!entry.isIntersecting));
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [sentinel]);

  return { isStuck, sentinelRef: setSentinel };
};
